import React from 'react';
import {
  Image,
  ImageBackground,
  TouchableOpacity,
  View,
  type ImageSourcePropType,
} from 'react-native';
import { Text } from '~/components';

interface Props {
  image: {
    background: { mobile: ImageSourcePropType; web: ImageSourcePropType };
    price: ImageSourcePropType;
  };
  bannerWidth: number;
  infos: {
    title: string;
    description: string;
  };
  button: {
    label: string;
    onPress?: () => void;
  };
  shortly?: boolean;
  className?: string;
}

const PresentationBanner: React.FC<Props> = ({
  image,
  bannerWidth,
  infos,
  button,
  shortly,
  className,
}) => {
  const width = bannerWidth;

  return (
    <>
      <View className="sm:hidden">
        <ImageBackground
          style={{ width, height: width * 1.5 }}
          source={image.background.mobile}
          className={`items-center p-3 ${className}`}
        >
          {shortly && (
            <View className="bg-warning-600 rounded-lg px-2 ml-12">
              <Text className="text-xs text-light-100">Em breve</Text>
            </View>
          )}
          <View className="justify-end flex-1">
            <Text className="text-sm font-medium text-light-100">
              {infos.title}
            </Text>
            <Text className="text-xs text-light-100 mb-2">
              {infos.description}
            </Text>

            <View
              className="sm:flex-row sm:items-center flex-col"
              style={{ width: width - 24 }}
            >
              <Image
                source={image.price}
                style={{
                  width: width - 24,
                  height: (width - 24) / 2.66,
                }}
              />
              <TouchableOpacity
                className="bg-primary-600 p-2 rounded-[5px] items-center justify-start mt-2 sm:ml-2"
                style={{ width: width - 24 }}
                activeOpacity={0.6}
                onPress={button.onPress}
              >
                <Text
                  className="text-[9px] font-medium text-light-100 text-center"
                  numberOfLines={1}
                >
                  {button.label}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </ImageBackground>
      </View>

      <View className="hidden sm:flex">
        <ImageBackground
          style={{ width: bannerWidth, height: bannerWidth / 1.36 }}
          source={image.background.web}
          className={`items-center p-4 ${className}`}
        >
          {shortly && (
            <View className="bg-warning-600 rounded-lg px-2 self-end">
              <Text className="text-xs text-light-100">Em breve</Text>
            </View>
          )}
          <View className="justify-end flex-1">
            <Text className="text-sm font-medium text-light-100">
              {infos.title}
            </Text>
            <Text className="text-xs text-light-100 mb-2">
              {infos.description}
            </Text>

            <View
              className="flex-row items-center"
              style={{ width: bannerWidth - 16 }}
            >
              <Image
                source={image.price}
                style={{
                  width: bannerWidth / 2 - 16,
                  height: (bannerWidth / 2 - 16) / 2.54,
                }}
              />
              <View className="w-full">
                <TouchableOpacity
                  className="bg-primary-600 p-2 rounded-[5px] items-center justify-start mt-2 sm:ml-2"
                  style={{ maxWidth: bannerWidth / 2 - 16 }}
                  activeOpacity={0.6}
                  onPress={button.onPress}
                >
                  <Text
                    className="text-[9px] font-medium text-light-100 text-center"
                    numberOfLines={2}
                  >
                    {button.label}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </ImageBackground>
      </View>
    </>
  );
};

export default PresentationBanner;
